var styleDataHash = "59744c55";
const injectCss = (() => {
  var css = `.F8fU7,.ghS2m{height:386px;margin-right:-16px;margin-top:20px;overflow:auto;padding-right:16px}.F8fU7.kOvjA,.ghS2m.kOvjA{height:calc(100vh - 190px)}.EPUNW{display:flex;flex-direction:column}.xya5T{float:right;text-align:right}.coCLN{cursor:pointer}.coCLN:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.pnnd5{margin-top:50px}.SQAPP,.pnnd5{height:100%;width:100%}.F8fU7,.SQAPP,.pnnd5{align-items:center;display:flex;justify-content:center}.F8fU7{max-width:100%}.OhZit{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "ghS2m",
  "giphySelectorErrorContainer": "F8fU7",
  "mobile": "kOvjA",
  "giphy_selector_infinite_scroll": "EPUNW",
  "giphy_selector_powerdByGiphy": "xya5T",
  "giphy_selector_gif_img_container": "coCLN",
  "giphy_selector_spinner_load_more": "pnnd5",
  "giphy_selector_spinner_empty_modal": "SQAPP",
  "searchInput": "OhZit"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
